import { Component } from '@angular/core';

@Component({
  selector: 'ui-panel-body',
  templateUrl: './panel-body.component.html'
})
export class PanelBodyComponent {

}